export interface ValidateStatus {
  validateStatus?: '' | 'success' | 'warning' | 'error' | 'validating' | undefined
  help?: string
}

export interface Paging {
  page: number
  pageSize: number
  total: number
  totalPage?: number
}

export interface ListData {
  data: any[]
  loading?: boolean
  paging: Paging
}

export interface IModalBase {
  visible: boolean
  record: any
}

export type ConfigCommonPriceType = 'weight' | 'volume'

export type TypeId = string | number | null | undefined

export const initialModalBase: IModalBase = {
  visible: false,
  record: {},
}

export const initialDataList: any = { data: [], paging: {}, loading: false }
export const initialDataDetail: any = {}
